import { useEffect } from "react"
import { useExperimentViewed } from "tracking/hooks/useExperimentViewed"

export const useCMSPageContentTracking = ({
  isPreview,
  experimentId,
  variation,
}: {
  isPreview: boolean
  experimentId?: string
  variation?: number | string
}): void => {
  const track = useExperimentViewed()
  useEffect(() => {
    const selectedVariantIdAsNumber = Number(variation)
    if (
      !isPreview &&
      !!experimentId &&
      !Number.isNaN(selectedVariantIdAsNumber)
    ) {
      track(experimentId, selectedVariantIdAsNumber)
    }
  }, [experimentId, isPreview, variation, track])
}
